/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Fmt_1Inputs */

const en_pc_online_fmt_1 = /** @type {(inputs: Pc_Online_Fmt_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens PDF files, including encrypted ones from 40-bit RC4 to AES-256 when you have the password.`)
};

const zh_pc_online_fmt_1 = /** @type {(inputs: Pc_Online_Fmt_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 PDF 文件，包括从 40 位 RC4 到 AES-256 的加密文件（需要你知道密码）。`)
};

/**
* | output |
* | --- |
* | "Opens PDF files, including encrypted ones from 40-bit RC4 to AES-256 when you have the password." |
*
* @param {Pc_Online_Fmt_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_fmt_1 = /** @type {((inputs?: Pc_Online_Fmt_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Fmt_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_fmt_1(inputs)
	return zh_pc_online_fmt_1(inputs)
});
export { pc_online_fmt_1 as "pc.online.fmt.1" }